import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, Box, Typography, MenuItem, CircularProgress, Alert } from '@mui/material';
import userApi from '../../api/userApi';
import tipoContrattoApi from '../../api/tipocontrattoApi';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { useNavigate, useSearchParams } from 'react-router-dom';

const profiles = ['CONTRIBUENTE', 'STUDIO'];
const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};
export default function RegisterPage() {
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState({
    username: '',
    password: '',
    email: '',
    profile: 'CONTRIBUENTE',
    nome: '',
    cognome: '',
    ragioneSociale: '',
    partitaIVA: '',
    emailStudio: '',
    tipoContrattoId: '',
    codiceInvito: '',
  });
  const [tipiContratto, setTipiContratto] = useState([]);
  const [err, setErr] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

    // ✅ PRECONFIGURAZIONE DA QUERY STRING
    useEffect(() => {
      const profileParam = searchParams.get('profile');
      const tipoContrattoParam = searchParams.get('tipoContrattoId');
      if (profileParam) {
        setForm(prev => ({
          ...prev,
          profile: profileParam,
          tipoContrattoId: tipoContrattoParam || ''
        }));
      }
    }, [searchParams]);

  useEffect(() => {
    async function fetchTipi() {
      try {
        const res = await tipoContrattoApi.getAllPublic();
        // Escludo BASIC
        setTipiContratto(res.data.filter(t => t.attivo && t.tipo !== 'BASIC'));
      } catch (e) {
        console.error(e);
      }
    }
    if(form.profile === 'STUDIO') fetchTipi();
  }, [form.profile]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await userApi.register(form);
      setLoading(false);
      navigate('/login');
    } catch (e) {
      setLoading(false);
      setErr(extractErrorMessage(e));
    }
  };

  return (
    <Container maxWidth="sm">
    <BackButtonDesktop />
      <Box sx={{ mt: 8 }}>
        <Typography variant="h5">Register</Typography>
        {err && <Alert severity="error" sx={{ my: 2 }}>{String(err)}</Alert>}
              {loading && (
                <Box sx={{ mt: 2 }}>
                  <CircularProgress />
                </Box>
              )}
        <form onSubmit={submit}>
          <TextField
            fullWidth
            select
            sx={{ my: 1 }}
            label="Tipologia utente"
            required
            value={form.profile}
            onChange={e => setForm({ ...form, profile: e.target.value })}
          >
            {profiles.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
          </TextField>
          <TextField
            fullWidth
            sx={{ my: 1 }}
            label="Username"
            required
            value={form.username}
            onChange={e => setForm({ ...form, username: e.target.value })}
          />
          <TextField
            fullWidth
            sx={{ my: 1 }}
            label="Email login"
            value={form.email}
            required
            onChange={e => setForm({ ...form, email: e.target.value })}
          />
          <TextField
            fullWidth
            sx={{ my: 1 }}
            type="password"
            label="Password"
            required
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
          />


          {form.profile === 'CONTRIBUENTE' && (
            <>
              <TextField
                fullWidth
                sx={{ my: 1 }}
                label="Nome"
                value={form.nome}
                required
                onChange={e => setForm({ ...form, nome: e.target.value })}
              />
              <TextField
                fullWidth
                sx={{ my: 1 }}
                label="Cognome/Rag. Sociale"
                required
                value={form.cognome}
                onChange={e => setForm({ ...form, cognome: e.target.value })}
              />
              <TextField
                fullWidth
                sx={{ my: 1 }}
                label="Partita IVA"
                  inputProps={{
                    maxLength: 11,
                    inputMode: "numeric",
                    pattern: "[0-9]{11}"
                  }}
                value={form.partitaIVA}
                onChange={e => setForm({ ...form, partitaIVA: e.target.value })}
              />

            <TextField
              fullWidth
              sx={{ my: 1 }}
              label="Codice studio (facoltativo, per associati a uno studio"
              value={form.codiceInvito}
              onChange={e => setForm({ ...form, codiceInvito: e.target.value })}
            />
            </>
          )}

          {form.profile === 'STUDIO' && (
            <>
              <TextField
                fullWidth
                select
                sx={{ my: 1 }}
                label="Tipo Contratto"
                required
                value={form.tipoContrattoId}
                onChange={e => setForm({ ...form, tipoContrattoId: e.target.value })}
              >
                {tipiContratto.map(t => (
                  <MenuItem key={t.id} value={t.id}>{t.tipo}</MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                sx={{ my: 1 }}
                label="Ragione Sociale"
                required
                value={form.ragioneSociale}
                onChange={e => setForm({ ...form, ragioneSociale: e.target.value })}
              />
              <TextField
                fullWidth
                sx={{ my: 1 }}
                label="Partita IVA"
                required
                inputProps={{
                        maxLength: 11,
                        inputMode: "numeric",
                        pattern: "[0-9]{11}"
                }}
                value={form.partitaIVA}
                onChange={e => setForm({ ...form, partitaIVA: e.target.value })}
              />
              <TextField
                fullWidth
                sx={{ my: 1 }}
                label="Email Studio (facoltativa)"
                value={form.emailStudio}
                onChange={e => setForm({ ...form, emailStudio: e.target.value })}
              />

            </>
          )}

          <Button variant="contained" sx={{ mt: 2 }} type="submit">
            Register
          </Button>
        </form>
      </Box>
    </Container>
  );
}